"use client"

import { GetPageByRouteQuery } from "apollo"
import { BlockRenderer } from "ui"
import { ArticlesData, getBreadCrumbs, transformProperties } from "utils"
import ArticleTabs from "./ArticleTabs"
import Breadcrumbs from "./Breadcrumbs"

type Props = {
  data: GetPageByRouteQuery
  locale: string
  articlesData: ArticlesData[]
}

const components = {
  adynamicTitleAndContant: () => import("../Common/DynamicTitle"),
}

// Waiting for umbraco to be completed

export default function PeopleOfEgged({ data, locale, articlesData }: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)
  return (
    <>
      <Breadcrumbs breadCrumbs={breadCrumbs} />
      <ArticleTabs articlesData={articlesData} />
    </>
  )
}
